import { render, staticRenderFns } from "./RevenueMargin.vue?vue&type=template&id=ab5101ea&scoped=true&"
import script from "./RevenueMargin.vue?vue&type=script&lang=ts&"
export * from "./RevenueMargin.vue?vue&type=script&lang=ts&"
import style0 from "./RevenueMargin.vue?vue&type=style&index=0&id=ab5101ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5101ea",
  null
  
)

export default component.exports